var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6647 11.3334C4.97733 11.3414 0.660663 6.97335 0.666663 1.33535C0.666663 0.966687 0.965329 0.666687 1.33333 0.666687H3.09333C3.42333 0.666687 3.704 0.909354 3.75266 1.23602C3.86873 2.01939 4.09661 2.78205 4.42933 3.50069L4.498 3.64869C4.54412 3.74828 4.55404 3.86085 4.52605 3.96698C4.49806 4.0731 4.43391 4.16613 4.34466 4.23002C3.79933 4.61935 3.59133 5.40269 4.016 6.01335C4.55065 6.78224 5.21796 7.44977 5.98666 7.98469C6.598 8.40869 7.38133 8.20069 7.77 7.65602C7.83382 7.56651 7.92692 7.50212 8.03321 7.47399C8.13949 7.44587 8.25225 7.45579 8.352 7.50202L8.49933 7.57002C9.218 7.90335 9.98066 8.13135 10.764 8.24735C11.0907 8.29602 11.3333 8.57669 11.3333 8.90735V10.6667C11.3333 10.7543 11.3161 10.841 11.2825 10.922C11.249 11.0029 11.1998 11.0764 11.1378 11.1383C11.0759 11.2002 11.0023 11.2493 10.9213 11.2828C10.8404 11.3163 10.7536 11.3334 10.666 11.3334H10.6647Z",
    stroke: "#505762"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.b24f3a93ab2768eabf58bfa7201e7d5b.svg";
export { ForwardRef as ReactComponent };